import React, { Suspense, lazy } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import LearnHome from "./learn/LearnHome";
import TopicGrid from "./learn/TopicGrid";
import ConceptDetail from "./learn/ConceptDetail";

// Playground demos are heavy (CKEditor builds, d3, material-table) and
// rarely the landing page — split them out of the main bundle.
const D3Charts = lazy(() => import("./learnD3/rootchart"));
const GoogleCharts = lazy(() => import("./googleCharts/rootchart"));
const ReactDragAndDrop = lazy(() => import("./react_beautiful_dnd"));
const TreeExample = lazy(() => import("./react_tree_beard"));
const CKEditor = lazy(() => import("./ck_editor/ckEditor"));
const MaterialTableDemo = lazy(() => import("./data_tables/dataTable"));

class Routes extends React.Component {
  render() {
    return (
        <Suspense fallback={<div>Loading…</div>}>
        <Switch>
          <Redirect exact from="/" to="/learn/react" />
          <Redirect exact from="/hooks" to="/learn/react" />
          <Route path="/learn" exact component={LearnHome} />
          <Route path="/learn/:topicId" exact component={TopicGrid} />
          <Route path="/learn/:topicId/:conceptId" exact component={ConceptDetail} />
          <Route path="/d3" exact component={D3Charts} />
          <Route path="/google" exact component={GoogleCharts} />
          <Route path="/react/dnd" exact component={ReactDragAndDrop} />
          <Route path="/react/tree" exact component={TreeExample} />
          <Route path="/react/editor" exact component={CKEditor} />
          <Route path="/react/table" exact component={MaterialTableDemo} />
        </Switch>
        </Suspense>
    );
  }
}

export default Routes;
